import { combineReducers } from "@reduxjs/toolkit";

//reducers
import Auth from "./auth/slice";
import Settings from "./settings/slice";
import Game from "./game/slice";
import Tasks from "./tasks/slice";
import Energy from "./energy/slice";
import Jackpot from "./jackpot/slice";
import RoundMultiplier from "./roundmultiplier/slice";

const rootReducer = combineReducers({
  Auth,
  Settings,
  Game,
  Tasks,
  Energy,
  Jackpot,
  RoundMultiplier,
});

export default rootReducer;
